if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.setupSwipeHandlers();
      }

      setupSwipeHandlers() {
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        container.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        container.addEventListener('touchend', (e) => {
          const deltaX = e.changedTouches[0].screenX - this.touchStartX;
          const deltaY = e.changedTouches[0].screenY - this.touchStartY;
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            this.navigateMedia(deltaX < 0 ? 'next' : 'prev');
          }
        }, { passive: true });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      navigateMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeItem = this.querySelector('[data-media-id].active');
        if (!activeItem || mediaItems.length <= 1) return;

        const currentIndex = mediaItems.indexOf(activeItem);
        const nextIndex = direction === 'next'
          ? (currentIndex + 1) % mediaItems.length
          : (currentIndex - 1 + mediaItems.length) % mediaItems.length;

        const nextItem = mediaItems[nextIndex];
        mediaItems.forEach(item => item.classList.remove('active'));
        nextItem.classList.add('active');
        nextItem.scrollIntoView({ block: 'nearest' });
      }
    }
  );
}